import React, { useState } from 'react';

const HamburgerMenu = ({ activeTab, setActiveTab, logout, tabs }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(prev => !prev);
    };

    return (
        <>
            <div className="hamburger-icon" onClick={toggleMenu}>
                &#9776;
            </div>

            <div className={`menu-overlay ${isOpen ? 'open' : ''}`}>
                <div className="close-icon" onClick={toggleMenu}>
                    &times;
                </div>
                <nav className="menu-content">
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            onClick={() => {
                                setActiveTab(tab);
                                toggleMenu();
                            }}
                            className={activeTab === tab ? "active" : ""}
                        >
                            {activeTab === tab ? <>🩷  {tab}  🩷</> : <>{tab}</>}

                        </button>
                    ))}
                    <button onClick={() => logout({ returnTo: window.location.origin })}>
                        Logout
                    </button>
                </nav>
            </div>
        </>
    );
};

export default HamburgerMenu;
